import { useEffect } from 'react';
import { useEnumStore } from '../store/enumStore';

interface UseInitializeEnumsReturn {
  loading: boolean;
  error: string | null;
}

export const useInitializeEnums = (): UseInitializeEnumsReturn => {
  const fetchAllEnums = useEnumStore((state) => state.fetchAllEnums);
  const loading = useEnumStore((state) => state.loading);
  const error = useEnumStore((state) => state.error);

  useEffect(() => {
    fetchAllEnums();
  }, [fetchAllEnums]);

  return { loading, error };
};

